import { doGet } from "../request";
import { PrivacyPolicyModel } from "models/privacy-policy";

export const doGetPrivacyPolicy = async () => {
  // there will be only one organization in the customer specific database
  const pp = await doGet<PrivacyPolicyModel>("/privacy-policy");
  return pp;
};
